export enum ApplicantType {
    None = 0,
    Private = 1,
    Corporate = 2,
    SoleProprietorship = 3,
}
